import { StorageService } from 'src/app/shared/services/storage.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { Menu } from './../../services/nav.service';
import { Injectable } from '@angular/core';
import { AgGridService } from '../ag-grid/ag-grid.service';

@Injectable({
  providedIn: 'root'
})
export class TabsService {
  allOpenedTabs = []
  tabs: Menu[] = [];
  addedTabs = new BehaviorSubject<Menu[]>([])
  currentTab = new BehaviorSubject<string>('')
  tabName = new BehaviorSubject<string>('')
  onSubNavChanged = new BehaviorSubject<any>(undefined);
  isOemAndVpl :boolean;

  thisTab = ''
  constructor(public storageService:StorageService,    public agGridService: AgGridService,) { }

  addTab(item) {
    let cleanName = ''
    this.agGridService.agGridPaginationConfig.pageSize = 25;
    if(typeof(item) == 'string'){
      cleanName = item?.substring(item.lastIndexOf('/') + 1);
    }
    if(typeof(item) == 'object'){
      cleanName = item?.path?.substring(item?.path.lastIndexOf('/') + 1);
    this.tabName.next(item.title)

    }
    this.currentTab.next(cleanName)
    var tabDetails = this.tabs?.find(a=>a.path == item.path && a.title == item.title )
    this.tabs = this.storageService.retrieve("allTabs");
    if(tabDetails == undefined && item.title !=  undefined)
    {
      this.tabs.push(item);
      let matchedTabs = this.tabs.filter(tab => tab.path === item.path);
      if (matchedTabs?.length > 1) {
        const tabToKeep = matchedTabs.find(tab => tab.title === item.title);
        this.tabs = this.tabs.filter(tab => {
          return tab.path !== item.path || (tab.title === tabToKeep?.title);
        });
      }
      this.storageService.store("allTabs",this.tabs);
      this.addedTabs.next(this.tabs);
    }
    
    }
   
  getTabItem(item: Menu) {
    return item
  }
   
  deleteTab(index: number) {
    this.tabs = this.storageService.retrieve("allTabs");
    this.tabs.splice(index, 1);
    this.storageService.store("allTabs",this.tabs);
    this.addedTabs.next(this.tabs);
  }
  deletedTabByList(ids: any[]) {
    this.tabs = this.storageService.retrieve("allTabs") ?? [];
    const hasMatchingTab = this.tabs.some(tab => ids.includes(tab.id));
    if (!hasMatchingTab) {
      return; 
    }
    this.tabs = this.tabs.filter(tab => !ids.includes(tab.id));
    this.storageService.store("allTabs", this.tabs);
    this.addedTabs.next(this.tabs);
  
    if (this.tabs.length > 0) {
      const nextTab = this.tabs[this.tabs.length - 1];
      this.currentTab.next(nextTab.path);
      this.tabName.next(nextTab.title);
    } else {

      this.currentTab.next('app-contacts'); 
      this.tabName.next('Contacts');
    }
  }
  
  updateName(item: any) {
    this.tabs = this.storageService.retrieve("allTabs") ?? [];
    const tabIndex = this.tabs.findIndex(tab => tab.id === item?.id);
    if (tabIndex === -1) {
        return; 
    }
    const oldTitle = this.tabs[tabIndex].title;
    const newTitle = item?.title;
    if (oldTitle !== newTitle) {
        this.tabs[tabIndex].title = newTitle;
        this.storageService.store("allTabs", this.tabs);
        this.addedTabs.next(this.tabs);
    }
}

}
